var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddWatermark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1C12.208 1 14 2.773 14 4.965c0 1.32-.66 2.548-1.751 3.282v1.295c0 .157.102.297.255.348l4.053 1.338c.562.185.942.707.942 1.297v1.542c0 .516-.42.933-.938.933H3.438a.935.935 0 01-.937-.933v-1.543c0-.59.38-1.111.942-1.296l4.053-1.339a.367.367 0 00.255-.347V8.247a3.947 3.947 0 01-1.215-5.264A4.006 4.006 0 0110 1zm0 0s0 0 0 0h0s0 0 0 0z",
    stroke: "#404143"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.5h16",
    stroke: "#404143",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWatermark);
export default __webpack_public_path__ + "static/media/add-watermark.svg";
export { ForwardRef as ReactComponent };